import { Icon, Flex } from '@qga/roo-ui/components';
import styled from '@emotion/styled';
import { useHeaderContext } from '../../HeaderContext';
import { formatNumber } from '../../../../lib/formatters';
import { themeGet } from 'styled-system';
import type { FC } from 'react';

export const QffPersonalInfo: FC = () => {
  const {
    firstName = '',
    lastName = '',
    memberId = '',
    membershipTier = '',
    pointsBalance = '',
  } = useHeaderContext().qffAuthData;
  return (
    <UserInfoCard>
      <Flex mb={2}>
        <Circle>
          <Icon name="person" size={16} pb="2px" />
        </Circle>
      </Flex>
      <Flex
        flexWrap="wrap"
        textAlign="center"
        data-testid="full-name-member-id"
      >
        {firstName} {lastName} ({memberId})
      </Flex>
      <Flex data-testid="points-balance">
        {formatNumber(pointsBalance)} points
      </Flex>
      <Flex data-testid="membership-tier">{membershipTier}</Flex>
    </UserInfoCard>
  );
};

const UserInfoCard = styled(Flex)`
  flex-direction: column;
  background-color: ${themeGet('colors.brand.primary')};
  color: ${themeGet('colors.white')};
  align-items: center;
  font-size: ${themeGet('fontSizes.header.base')};
  padding: ${themeGet('space.5')} ${themeGet('space.2')};
`;

const Circle = styled(Flex)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px white solid;
  align-items: center;
  justify-content: center;
`;
